<template>
  <el-carousel v-if="adData.length > 0" height="330px">
    <el-carousel-item
      v-for="item in adData"
      :key="item.id"
      @click="jumpToAdBlank(item.id, item.url)"
    >
      <div :style="`background-image: url(${item.image})`" class="bg-img"></div>
<!--      <el-image :src="item.image" class="carousel-image" fit="cover"></el-image>-->
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import usePublicize from "../../hooks/publicize/usePublicize";

export default {
  name: "static-publicize",
  props: {
    adData: {
      type: Array,
      default: [],
    },
    customStyle: {
      type: Object,
      default: () => {
        return {
          height: "400px",
        };
      },
    },
  },
  setup() {
    const { jumpToAdBlank } = usePublicize();
    return {
      jumpToAdBlank,
    };
  },
};
</script>

<style lang="less" scoped>
.bg-img {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.carousel-image {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  object-fit: cover;
  cursor: pointer;

  :deep(.el_image__inner) {
    object-fit: contain !important;
  }
}
</style>
